import React from 'react';

function Email({ lang }) {
    return (
        <div className="page-content" style={{ padding: '40px 20px', textAlign: 'center' }}>
            <p style={{ color: '#888', fontStyle: 'italic' }}>Email page — coming soon.</p>
        </div>
    );
}

export default Email;
